export default "__VITE_ASSET__BEU1zfa$__"